// import React from "react";
// import Assets from "../../Assets/Assets";

// const NotificationCenter = ({ notifications, unreadCount, onMarkAsRead, onMarkAllRead }) => {

//   const getTypeColor = (type) => {
//     switch (type) {
//       case 'new_appointment':         return 'text-success';
//       case 'new_patient_visit':       return 'text-success';
//       case 'appointment_rescheduled': return 'text-warning';
//       case 'appointment_cancelled':   return 'text-danger';
//       case 'followup_missed':         return 'text-danger';
//       case 'daily_schedule_reminder': return 'text-primary';
//       case 'weekly_summary':          return 'text-info';
//       case 'profile_incomplete':      return 'text-warning';
//       default:                        return 'text-dark';
//     }
//   };

//   const formatTime = (dateStr) => {
//     if (!dateStr) return '';
//     return new Date(dateStr).toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div className="dropdown">
//       <button
//         className="btn btn-light position-relative border-0 bg-transparent p-0 mt-2"
//         data-bs-toggle="dropdown"
//         aria-expanded="false"
//       >
//         <img
//           src={Assets.notify_icon}
//           alt="Notification"
//           className="icon"
//           style={{ width: '34px', height: '34px' }}
//         />

//         {unreadCount > 0 && (
//           <span
//             className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger border border-2 border-white"
//             style={{
//               fontSize: '0.65rem',
//               padding: '2px 6px',
//               minWidth: '18px',
//               height: '18px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             {unreadCount > 99 ? '99+' : unreadCount}
//           </span>
//         )}
//       </button>

//       {/* Dropdown */}
//       <ul
//         className="dropdown-menu dropdown-menu-end shadow"
//         style={{ width: '320px', borderRadius: '12px' }}
//       >
//         {/* Header */}
//         <li className="px-3 py-2 d-flex justify-content-between align-items-center border-bottom">
//           <span className="fw-bold">
//             Notifications
//             {unreadCount > 0 && (
//               <span className="ms-2 badge bg-danger rounded-pill" style={{ fontSize: '0.65rem' }}>
//                 {unreadCount}
//               </span>
//             )}
//           </span>
//           {notifications.length > 0 && (
//             <button
//               className="btn btn-link btn-sm text-decoration-none text-danger p-0"
//               onClick={onMarkAllRead}
//             >
//               Mark all read
//             </button>
//           )}
//         </li>

//         {/* List */}
//         <div style={{ maxHeight: '360px', overflowY: 'auto' }}>
//           {notifications.length > 0 ? (
//             notifications.map((n) => (
//               <li
//                 key={n.id}
//                 className="px-3 py-2 border-bottom"
//                 onClick={() => !n.is_read && onMarkAsRead(n.id)}
//                 style={{
//                   cursor:     n.is_read ? 'default' : 'pointer',
//                   background: n.is_read ? 'transparent' : '#f0f7ff',
//                   transition: 'background 0.2s',
//                 }}
//               >
//                 <div className="d-flex justify-content-between align-items-start">
//                   <small className={`fw-bold ${getTypeColor(n.type)}`}>
//                     {n.title}
//                   </small>
//                   <div className="d-flex align-items-center gap-1 ms-2">
//                     <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
//                       {formatTime(n.created_at)}
//                     </small>
//                     {!n.is_read && (
//                       <span
//                         style={{
//                           width: '7px', height: '7px',
//                           borderRadius: '50%',
//                           background: '#0d6efd',
//                           display: 'inline-block',
//                           flexShrink: 0,
//                         }}
//                       />
//                     )}
//                   </div>
//                 </div>
//                 <small className="text-secondary d-block mt-1">{n.message}</small>
//               </li>
//             ))
//           ) : (
//             <li className="px-3 py-3 text-center text-muted small">
//               No new notifications
//             </li>
//           )}
//         </div>
//       </ul>
//     </div>
//   );
// };

// export default NotificationCenter;

import React, { useEffect, useRef, useState } from "react";
import Assets from "../../Assets/Assets";

const NotificationCenter = ({ notifications, unreadCount, onMarkAsRead, onMarkAllRead, onNotificationClick }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getTypeColor = (type) => {
    switch (type) {
      case 'new_appointment':         return 'text-success';
      case 'new_patient_visit':       return 'text-success';
      case 'appointment_rescheduled': return 'text-warning';
      case 'appointment_cancelled':   return 'text-danger';
      case 'followup_missed':         return 'text-danger';
      case 'daily_schedule_reminder': return 'text-primary';
      case 'weekly_summary':          return 'text-info';
      case 'profile_incomplete':      return 'text-warning';
      default:                        return 'text-dark';
    }
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleItemClick = (n) => {
    if (onNotificationClick) {
      onNotificationClick(n);
    } else if (!n.is_read) {
      onMarkAsRead(n.id);
    }
    setOpen(false);
  };

  const handleClearAll = () => {
    onMarkAllRead();
    setOpen(false);
  };

  return (
    <div
      className="position-relative d-inline-block"
      ref={wrapperRef}
    >
      <button
        className="btn btn-light position-relative border-0 bg-transparent p-0 mt-2"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <img
          src={Assets.notify_icon}
          alt="Notification"
          className="icon"
          style={{ width: '34px', height: '34px' }}
        />

        {unreadCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger border border-2 border-white"
            style={{
              fontSize: '0.65rem',
              padding: '2px 6px',
              minWidth: '18px',
              height: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <ul
          className="shadow"
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            left: 'auto',
            width: '320px',
            maxWidth: '90vw',
            borderRadius: '12px',
            background: '#fff',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            zIndex: 1050,
            border: '1px solid rgba(0,0,0,0.08)',
          }}
        >
          {/* Header */}
          <li className="px-3 py-2 d-flex justify-content-between align-items-center border-bottom">
            <span className="fw-bold">
              Notifications
              {unreadCount > 0 && (
                <span className="ms-2 badge bg-danger rounded-pill" style={{ fontSize: '0.65rem' }}>
                  {unreadCount}
                </span>
              )}
            </span>
            {notifications.length > 0 && (
              <button
                className="btn btn-link btn-sm text-decoration-none text-danger p-0"
                onClick={handleClearAll}
              >
                Clear
              </button>
            )}
          </li>

          {/* List */}
          <div style={{ maxHeight: '360px', overflowY: 'auto' }}>
            {notifications.length > 0 ? (
              notifications.map((n) => (
                <li
                  key={n.id}
                  className="px-3 py-2 border-bottom"
                  onClick={() => handleItemClick(n)}
                  style={{
                    cursor:     n.is_read ? 'default' : 'pointer',
                    background: n.is_read ? 'transparent' : '#f0f7ff',
                    transition: 'background 0.2s',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <small className={`fw-bold ${getTypeColor(n.type)}`}>
                      {n.title}
                    </small>
                    <div className="d-flex align-items-center gap-1 ms-2">
                      <small className="text-muted" style={{ whiteSpace: 'nowrap' }}>
                        {formatTime(n.created_at)}
                      </small>
                      {!n.is_read && (
                        <span
                          style={{
                            width: '7px', height: '7px',
                            borderRadius: '50%',
                            background: '#0d6efd',
                            display: 'inline-block',
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <small className="text-secondary d-block mt-1">{n.message}</small>
                </li>
              ))
            ) : (
              <li className="px-3 py-3 text-center text-muted small">
                No new notifications
              </li>
            )}
          </div>
        </ul>
      )}
    </div>
  );
};

export default NotificationCenter;